var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('VJsoneditor',{key:_vm.key,ref:"jsonEditor",attrs:{"height":"300px","options":_vm.options,"plus":false},model:{value:(_vm.jsonData),callback:function ($$v) {_vm.jsonData=$$v},expression:"jsonData"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }